import { deriveOverallHealth, type MspHealthPrototypeModel, type PrototypeHealthDomain } from './model.js';

export function createDashboardPendingModel(message: string): MspHealthPrototypeModel {
  const categories: readonly PrototypeHealthDomain[] = [
    {
      label: 'Observed Backup Health',
      score: null,
      tone: 'ATTENTION',
      dataKind: 'LIVE',
      overallParticipation: 'ACTIVE',
      supportingText: message,
    },
    {
      label: 'Microsoft 365 Health',
      score: null,
      tone: 'HEALTHY',
      dataKind: 'PLACEHOLDER',
      overallParticipation: 'PLANNED',
      supportingText: 'Not connected',
    },
    {
      label: 'Servers',
      score: null,
      tone: 'HEALTHY',
      dataKind: 'PLACEHOLDER',
      overallParticipation: 'PLANNED',
      supportingText: 'Not connected',
    },
    {
      label: '3CX',
      score: null,
      tone: 'HEALTHY',
      dataKind: 'PLACEHOLDER',
      overallParticipation: 'PLANNED',
      supportingText: 'Planned',
    },
    {
      label: 'Onboarding',
      score: null,
      tone: 'HEALTHY',
      dataKind: 'PLACEHOLDER',
      overallParticipation: 'PLANNED',
      supportingText: 'Planned',
    },
    {
      label: 'Projects',
      score: null,
      tone: 'HEALTHY',
      dataKind: 'PLACEHOLDER',
      overallParticipation: 'PLANNED',
      supportingText: 'Planned',
    },
  ];
  return {
    generatedAtLabel: message,
    managedClientCount: 0,
    overall: deriveOverallHealth(categories),
    categories,
    clients: [],
    issues: [],
  };
}
